import qs from 'query-string'
import { useCallback, useContext, useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { type Utm } from 'core/domain/Utm'

import { LOAD_BOARD_ACTIONS, LoadBoardContext } from 'legacy/contexts/loadBoard'

import { type BookingType, type OfferType } from '../../domain/LoadOffer'
import { BookConfirmationDialog } from './BookConfirmationDialog'

export function BookConfirmation() {
  const location = useLocation()
  const history = useHistory()
  const [{ bookingOffer }, dispatch] = useContext(LoadBoardContext)

  const { pathname, search } = location
  const { bookingOfferId, bookingType, ...query } = useMemo(() => qs.parse(search), [search])
  const { utm_source, utm_campaign, utm_medium, ref_id }: Utm = query
  const utmParams = useMemo<Utm>(() => {
    return { utm_source, utm_campaign, utm_medium, ref_id }
  }, [utm_source, utm_campaign, utm_medium, ref_id])

  const isBooking = bookingOfferId != null

  const clearBookingInSearch = useCallback(() => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        bookingStep: undefined,
      })}`
    )
  }, [history, pathname, query])

  const clearBookingInContext = useCallback(() => {
    dispatch({ type: LOAD_BOARD_ACTIONS.CLEAR_BOOK_OFFER })
  }, [dispatch])

  function handleConfirm(offerType: OfferType) {
    dispatch({
      type: LOAD_BOARD_ACTIONS.MARK_OFFER_TAKEN,
      payload: { loadUUID: bookingOfferId as string },
    })

    history.push(`/loads/${bookingOfferId}/setup`)
  }

  function handleCancel() {
    clearBookingInSearch()
    clearBookingInContext()
  }

  useEffect(() => {
    if (!isBooking) {
      clearBookingInContext()
    }
  }, [isBooking, clearBookingInContext])

  if (!isBooking) {
    return null
  }

  return (
    <BookConfirmationDialog
      loadOfferId={bookingOfferId as string}
      bookingOffer={bookingOffer}
      bookingType={bookingType as BookingType}
      utmParams={utmParams}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  )
}
